import {
  Box,
  TextField,
  Grid,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  MenuItem
} from "@mui/material";

const PaymentInfoForm = ({ formData, handleChange }) => {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h6" gutterBottom>
        บัญชีธนาคารสำหรับโอนเงิน
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="ชื่อบัญชี"
            value={formData.bankAccountName}
            onChange={handleChange("bankAccountName")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            select
            fullWidth
            label="ธนาคาร"
            value={formData.bankName}
            onChange={handleChange("bankName")}
          >
            {[
              "กรุงเทพ",
              "กสิกรไทย",
              "กรุงไทย",
              "กรุงศรีอยุธยา",
              "ไทยพาณิชย์",
              "ทหารไทยธนชาต",
              "ยูโอบี",
              "ซีไอเอ็มบีไทย",
              "เกียรตินาคินภัทร",
              "ออมสิน",
              "ธ.ก.ส.",
            ].map((bank) => (
              <MenuItem key={bank} value={bank}>
                {bank}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="เลขที่บัญชี"
            value={formData.bankAccountNumber}
            onChange={handleChange("bankAccountNumber")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="สาขา"
            value={formData.bankBranch}
            onChange={handleChange("bankBranch")}
          />
        </Grid>

        {/* การคำนวณภาษีซื้อ */}
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <FormLabel>การคำนวณภาษีซื้อ</FormLabel>
            <RadioGroup
              value={formData.purchaseTaxOption}
              onChange={handleChange("purchaseTaxOption")}
            >
              <FormControlLabel
                value="default"
                control={<Radio />}
                label="ใช้ค่าเริ่มต้น (ไม่คำนวณภาษีมูลค่าเพิ่ม)"
              />
              <FormControlLabel
                value="noVat"
                control={<Radio />}
                label="ไม่คำนวณภาษีมูลค่าเพิ่ม"
              />
              <FormControlLabel
                value="vatIncluded"
                control={<Radio />}
                label="ยอดรวมภาษีมูลค่าเพิ่มแล้ว"
              />
              <FormControlLabel
                value="vatExcluded"
                control={<Radio />}
                label="ยอดยังไม่รวมภาษีมูลค่าเพิ่ม"
              />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* การคำนวณภาษีขาย */}
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <FormLabel>การคำนวณภาษีขาย</FormLabel>
            <RadioGroup
              value={formData.salesTaxOption}
              onChange={handleChange("salesTaxOption")}
            >
              <FormControlLabel
                value="default"
                control={<Radio />}
                label="ใช้ค่าเริ่มต้น (ไม่คำนวณภาษีมูลค่าเพิ่ม)"
              />
              <FormControlLabel
                value="noVat"
                control={<Radio />}
                label="ไม่คำนวณภาษีมูลค่าเพิ่ม"
              />
              <FormControlLabel
                value="vatIncluded"
                control={<Radio />}
                label="ยอดรวมภาษีมูลค่าเพิ่มแล้ว"
              />
              <FormControlLabel
                value="vatExcluded"
                control={<Radio />}
                label="ยอดยังไม่รวมภาษีมูลค่าเพิ่ม"
              />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* การปัดเศษจำนวน */}

        <Grid item xs={12}>
          <FormControl fullWidth>
            <FormLabel>การปัดเศษจำนวน</FormLabel>
            <RadioGroup
              value={formData.roundingOption}
              onChange={handleChange("roundingOption")}
            >
              <FormControlLabel
                value="none"
                control={<Radio />}
                label="ไม่ปัดเศษ"
              />
              <FormControlLabel
                value="alwaysRound"
                control={<Radio />}
                label="ปัดเศษเสมอ"
              />
              <FormControlLabel
                value="never"
                control={<Radio />}
                label={
                  <Box>
                    ปัดขึ้นเสมอ
                    <br />
                    <Typography variant="caption" color="textSecondary">
                      เช่น 1.01 ปัดขึ้นเป็น 2.00, 1.56 ปัดขึ้นเป็น 2.00
                    </Typography>
                  </Box>
                }
              />
              <FormControlLabel
                value="whenGreaterOrEqual50"
                control={<Radio />}
                label={
                  <Box>
                    ปัดขึ้นเป็น 1 เมื่อตัวเลข &gt;= 0.50 เท่านั้น
                    <br />
                    <Typography variant="caption" color="textSecondary">
                      เช่น 1.56 ปัดขึ้นเป็น 2.00, 1.49 ปัดลงเป็น 1.00
                    </Typography>
                  </Box>
                }
              />
              <FormControlLabel
                value="between00and50"
                control={<Radio />}
                label={
                  <Box>
                    ปัดขั้น 0.50 เมื่อตัวเลข &gt; 0.00 หรือ &gt; 0.50
                    <br />
                    <Typography variant="caption" color="textSecondary">
                      เช่น 1.01 ปัดขึ้นเป็น 1.50, 1.78 ปัดขึ้นเป็น 2.00
                    </Typography>
                  </Box>
                }
              />
              <FormControlLabel
                value="between025and075"
                control={<Radio />}
                label={
                  <Box>
                    ปัดขึ้น 0.50 เมื่อตัวเลข ≥ 0.25 หรือ ≥ 0.75
                    <br />
                    <Typography variant="caption" color="textSecondary">
                      เช่น 1.26 ปัดขึ้นเป็น 1.50, 1.78 ปัดขึ้นเป็น 2.00
                    </Typography>
                  </Box>
                }
              />
              <FormControlLabel
                value="alwaysClose"
                control={<Radio />}
                label={
                  <Box>
                    ปิดลงเสมอ
                    <br />
                    <Typography variant="caption" color="textSecondary">
                      เช่น 1.56 ปัดลงเป็น 1.00,1.01 ปัดลงเป็น 1.00
                    </Typography>
                  </Box>
                }
              />
              <FormControlLabel
                value="lessThan100or050"
                control={<Radio />}
                label={
                  <Box>
                    ปิดลง 0.50 เมื่อตัวเลข &lt; 1.00 หรือ &lt; 0.50
                    <br />
                    <Typography variant="caption" color="textSecondary">
                      เช่น 1.56 ปิดลงเป็น 1.50, 1.45 ปัดลงเป็น 1.00
                    </Typography>
                  </Box>
                }
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaymentInfoForm;
